import { Button } from 'react-admin'
import { client } from '../providers/data/client'

export default function RefreshOrderButton({ notify, refresh, setLoading }) {
  return (
    <Button type="button" className="btn btn-default" onClick={() => refreshOrders(notify, refresh, setLoading)}>
      <p>
        <span className="fa-solid fa-barcode" aria-hidden="true"></span>&nbsp;Refresh Orders from Shopify
      </p>
    </Button>
  )
}

const refreshOrders = async (notify, refresh, setLoading) => {
  let refreshMsg = 'Unknown'

  notify('Shopify Order Refresh starting ...', {
    type: 'success',
    multiline: true,
  })

  try {
    setLoading(true)
    const response = await client().post('/util/refreshOrders', {
      status: 'any',
      limit: 100,
    })

    let nNew = 0
    response.data.orderMetaData.forEach(function (omd) {
      nNew += omd.inserted ? 1 : 0
    })
    refreshMsg = 'Shopify Order Refresh complete\n\nNew orders: ' + nNew

    setLoading(false)
    refresh()
    notify(refreshMsg, {
      type: 'success',
      multiline: true,
    })
  } catch (error) {
    let errorMessage = 'Failed to refresh orders.'

    if (error.response.data.message) {
      errorMessage = error.response.data.message
    } else if (error.response.data.error) {
      errorMessage = error.response.data.error
    } else if (error.message) {
      errorMessage = error.message
    }

    notify(errorMessage, {
      type: 'error',
      multiline: true,
    })
    setLoading(false)
  }
}
